import { Button, Input, Title } from "../../uikit";
import Header from "../Header";
import { useNavigate } from "react-router";

import { useTranslation } from "react-i18next";
import ErrorMessage from "../ErrorMessage";
import { useState } from "react";
import { DOMAIN } from "../../consts";
import { getUserData } from "../../utils/Api";
import getMiniappInitData from "../../telegramMiniapp";
import { saveToken, clearToken } from "../../utils/tokenStorage";
import trackUmamiEvent from "../../utils/umami";

export default function SignupEmail({ setVariant = () => {} }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const requestAuth = async (path, body) => {
    const response = await fetch(DOMAIN + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    let payload = {};
    try {
      payload = await response.json();
    } catch {}

    if (!response.ok) {
      const detail = payload?.detail;
      const message =
        typeof detail === "string"
          ? detail
          : payload?.message || "Something went wrong";
      throw new Error(message);
    }

    return payload;
  };

  const sendConfirmationCode = async () => {
    try {
      setIsLoading(true);
      if (username == "" || password == "") {
        setErrorMessage("Fill all fields");
        return;
      }
      if (password.length < 8) {
        setErrorMessage(t("Password too short"));
        return;
      }
      setErrorMessage("");
      const data = {
        username,
        password,
        lang: localStorage.getItem("lang") || "ru",
      };
      const authData = getMiniappInitData();
      if (authData?.tgWebAppData) {
        data.telegram_data = authData.tgWebAppData;
      }
      await requestAuth("/auth/signup/request", data);
      setIsCodeSent(true);
    } catch (e) {
      setErrorMessage(t(e?.message || "Something went wrong"));
    } finally {
      setIsLoading(false);
    }
  };

  const confirmSignup = async () => {
    try {
      setIsLoading(true);
      if (code == "") {
        setErrorMessage("Fill all fields");
        return;
      }
      setErrorMessage("");
      const data = {
        username,
        password,
        code,
        lang: localStorage.getItem("lang") || "ru",
      };
      const authData = getMiniappInitData();
      if (authData?.tgWebAppData) {
        data.telegram_data = authData.tgWebAppData;
      }
      const result = await requestAuth("/auth/signup/confirm", data);
      if (result.success) {
        trackUmamiEvent("Signup", { method: "email" });
        saveToken(result.token);
        const [success, profile] = await getUserData();
        if (!success) {
          clearToken();
          setErrorMessage("Something went wrong");
          return;
        }
        localStorage.setItem("lang", profile.lang);
        navigate("/account");
      }
    } catch (e) {
      setErrorMessage(t(e?.message || "Something went wrong"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="column card wide">
      <Header
        isBack={true}
        backCallback={() => setVariant("start")}
        className="row"
      >
        <Title level="1" weight="3">
          {t("Signup")}
        </Title>
      </Header>
      {isCodeSent ? (
        <>
          <div className="row">
            {t("The confirmation code has been sent to your email address")}
          </div>
          <Input
            className="wide mb-1"
            header={t("Confirmation code")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <ErrorMessage errorMessage={errorMessage} />
          <Button
            mode="filled"
            size="l"
            className="row"
            onClick={confirmSignup}
            loading={isLoading}
            disabled={isLoading}
          >
            {t("Confirm email")}
          </Button>
        </>
      ) : (
        <>
          <Input
            className="wide"
            header={t("Email")}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            type="password"
            className="wide mb-1"
            header={t("Password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <ErrorMessage errorMessage={errorMessage} />
          <Button
            mode="filled"
            size="l"
            className="row"
            onClick={sendConfirmationCode}
            loading={isLoading}
            disabled={isLoading}
          >
            {t("Send confirmation code")}
          </Button>
        </>
      )}
    </div>
  );
}
